import { UserCancellationInterceptOutcomesMapper } from "@vendor-app/mappers/UserCancellationInterceptOutcomes/mapper";

import UserCancellationInterceptOutcomesGateway from "./gateway";

const userCancellationInterceptOutcomesGateway = new UserCancellationInterceptOutcomesGateway(
  new UserCancellationInterceptOutcomesMapper()
);

export default userCancellationInterceptOutcomesGateway;
